var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-20"},[_c('div',{staticClass:"text-center my-5"},[_c('b-spinner',{staticClass:"loader",attrs:{"label":"Spinner"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }